import React from "react";
import "./tooltipHL.css";
import { Tooltip } from "@progress/kendo-react-tooltip";

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const TooltipHLPure = (props) => {
  const {
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description
    restContent, //More text to tooltip description
    informationIcon, // Choose the information icon true or false to custom img
    customImg, //Send custom image tooltip
    refCustomImg, //reference image when this use some service or input file
    altCustomImg, //alt custom img
    styleCustomImg, //style custom img
    openTooltipDescription, //True to open description tooltip or false to close.
    freeContent
  } = props;

  const TooltipContentTemplate = (props) => {
    return (
      <div className="tooltipHLPure-styleBox">
        <h3>{props.title}</h3>
        <p>{props.content}</p>
        {subContent ? <p>{props.subContent}</p> : ""}
        {restContent ? <p>{props.restContent}</p> : ""}
        {freeContent}
      </div>
    );
  };

  return (
    <Tooltip
      anchorElement="target"
      position={positionTooltip}
      open={openTooltipDescription}
      openDelay={100}
      content={(props) => (
        <TooltipContentTemplate
          title={titleTooltip}
          content={descriptionTooltip}
          subContent={subContent}
          restContent={restContent}
          freeContent={freeContent}
        />
      )}
    >
      <div style={{ display: 'flex ' }}>
        {informationIcon ? (
          <span
            className="tooltipHLPure-icon k-icon k-i-information"
            title={titleTooltip || 'info-icon'}
            content={descriptionTooltip}
          />
        ) : (
          <img
            id="imgProfile"
            src={customImg}
            ref={refCustomImg}
            altCustomImg={altCustomImg}
            className={styleCustomImg}
            title={titleTooltip}
            content={descriptionTooltip}
          />
        )}
      </div>
    </Tooltip>
  );
};

export { TooltipHLPure as default };
//Tooltip HTML
{
  /* <div className="tooltipHLPure-container">
        <i className="tooltipHLPure-icon k-icon k-i-information" />
        <div className="tooltipHLPure-text">
          <label className="tooltipHLPure-title">{titleTooltip}</label>
          <p className="tooltipHLPure-description">{descriptionTooltip}</p>
        </div>
      </div> */
}
